module.exports = __webpack_public_path__ + "media/thumbnails/glove-style-3-472e939d.svg";